export const FIFA_GROUPS = [{
  id: 'groupA',
  name: 'Группа A',
  teams: [{
    id: 'WYintcWb',
    name: 'Нидерланды',
    games: 3,
    points: 7,
    goalsScored: 5,
    goalsAgainst: 1,
    countryCode: 'NL',
    flagUrl: 'https://cdn.nur.kz/static/football/NL.png'
  }, {
    id: 'hOIsJLJr',
    name: 'Сенегал',
    games: 3,
    points: 6,
    goalsScored: 5,
    goalsAgainst: 4,
    countryCode: 'SN',
    flagUrl: 'https://cdn.nur.kz/static/football/SN.png'
  }, {
    id: '8tbm8Tri',
    name: 'Эквадор',
    games: 3,
    points: 4,
    goalsScored: 4,
    goalsAgainst: 3,
    countryCode: 'EC',
    flagUrl: 'https://cdn.nur.kz/static/football/EC.png'
  }, {
    id: 'zqzHL77i',
    name: 'Катар',
    games: 3,
    points: 0,
    goalsScored: 1,
    goalsAgainst: 7,
    countryCode: 'QA',
    flagUrl: 'https://cdn.nur.kz/static/football/QA.png'
  }]
}, {
  id: 'groupB',
  name: 'Группа B',
  teams: [{
    id: 'j9N9ZNFA',
    name: 'Англия',
    games: 3,
    points: 7,
    goalsScored: 9,
    goalsAgainst: 2,
    countryCode: 'GB',
    flagUrl: 'https://cdn.nur.kz/static/football/GB.png'
  }, {
    id: 'fuitL4CF',
    name: 'США',
    games: 3,
    points: 5,
    goalsScored: 2,
    goalsAgainst: 1,
    countryCode: 'US',
    flagUrl: 'https://cdn.nur.kz/static/football/US.png'
  }, {
    id: 'xrRx85iA',
    name: 'Иран',
    games: 3,
    points: 3,
    goalsScored: 4,
    goalsAgainst: 7,
    countryCode: 'IR',
    flagUrl: 'https://cdn.nur.kz/static/football/IR.png'
  }, {
    id: 'YcUP0Nqp',
    name: 'Уэльс',
    games: 3,
    points: 1,
    goalsScored: 1,
    goalsAgainst: 6,
    countryCode: 'WS',
    flagUrl: 'https://cdn.nur.kz/static/football/WS.png'
  }]
}, {
  id: 'groupC',
  name: 'Группа C',
  teams: [{
    id: 'f9OppQjp',
    name: 'Аргентина',
    games: 3,
    points: 6,
    goalsScored: 5,
    goalsAgainst: 2,
    countryCode: 'AR',
    flagUrl: 'https://cdn.nur.kz/static/football/AR.png'
  }, {
    id: '2HzmcynI',
    name: 'Польша',
    games: 3,
    points: 4,
    goalsScored: 2,
    goalsAgainst: 2,
    countryCode: 'PL',
    flagUrl: 'https://cdn.nur.kz/static/football/PL.png'
  }, {
    id: 'O6iHcNkd',
    name: 'Мексика',
    games: 3,
    points: 4,
    goalsScored: 2,
    goalsAgainst: 3,
    countryCode: 'MX',
    flagUrl: 'https://cdn.nur.kz/static/football/MX.png'
  }, {
    id: 'biSY8ox4',
    name: 'С.Аравия',
    games: 3,
    points: 3,
    goalsScored: 3,
    goalsAgainst: 5,
    countryCode: 'SA',
    flagUrl: 'https://cdn.nur.kz/static/football/SA.png'
  }]
}, {
  id: 'groupD',
  name: 'Группа D',
  teams: [{
    id: 'QkGeVG1n',
    name: 'Франция',
    games: 3,
    points: 6,
    goalsScored: 6,
    goalsAgainst: 3,
    countryCode: 'FR',
    flagUrl: 'https://cdn.nur.kz/static/football/FR.png'
  }, {
    id: 'xSrf6qMM',
    name: 'Австралия',
    games: 3,
    points: 6,
    goalsScored: 3,
    goalsAgainst: 4,
    countryCode: 'AU',
    flagUrl: 'https://cdn.nur.kz/static/football/AU.png'
  }, {
    id: 'QqZVYk95',
    name: 'Тунис',
    games: 3,
    points: 4,
    goalsScored: 1,
    goalsAgainst: 1,
    countryCode: 'TN',
    flagUrl: 'https://cdn.nur.kz/static/football/TN.png'
  }, {
    id: '0KUdxQVi',
    name: 'Дания',
    games: 3,
    points: 1,
    goalsScored: 1,
    goalsAgainst: 3,
    countryCode: 'DK',
    flagUrl: 'https://cdn.nur.kz/static/football/DK.png'
  }]
}, {
  id: 'groupE',
  name: 'Группа E',
  teams: [{
    id: 'ULXPdOUj',
    name: 'Япония',
    games: 3,
    points: 6,
    goalsScored: 4,
    goalsAgainst: 3,
    countryCode: 'JP',
    flagUrl: 'https://cdn.nur.kz/static/football/JP.png'
  }, {
    id: 'bLyo6mco',
    name: 'Испания',
    games: 3,
    points: 4,
    goalsScored: 9,
    goalsAgainst: 3,
    countryCode: 'ES',
    flagUrl: 'https://cdn.nur.kz/static/football/ES.png'
  }, {
    id: 'ptQide1O',
    name: 'Германия',
    games: 3,
    points: 4,
    goalsScored: 6,
    goalsAgainst: 5,
    countryCode: 'DE',
    flagUrl: 'https://cdn.nur.kz/static/football/DE.png'
  }, {
    id: 'C4ePE2kq',
    name: 'Коста-Рика',
    games: 3,
    points: 3,
    goalsScored: 3,
    goalsAgainst: 11,
    countryCode: 'CR',
    flagUrl: 'https://cdn.nur.kz/static/football/CR.png'
  }]
}, {
  id: 'groupF',
  name: 'Группа F',
  teams: [{
    id: 'IDKYO3R8',
    name: 'Марокко',
    games: 3,
    points: 7,
    goalsScored: 4,
    goalsAgainst: 1,
    countryCode: 'MA',
    flagUrl: 'https://cdn.nur.kz/static/football/MA.png'
  }, {
    id: 'K8aznggo',
    name: 'Хорватия',
    games: 3,
    points: 5,
    goalsScored: 4,
    goalsAgainst: 1,
    countryCode: 'HR',
    flagUrl: 'https://cdn.nur.kz/static/football/HR.png'
  }, {
    id: 'GbB957na',
    name: 'Бельгия',
    games: 3,
    points: 4,
    goalsScored: 1,
    goalsAgainst: 2,
    countryCode: 'BE',
    flagUrl: 'https://cdn.nur.kz/static/football/BE.png'
  }, {
    id: 'x4toKORL',
    name: 'Канада',
    games: 3,
    points: 0,
    goalsScored: 2,
    goalsAgainst: 7,
    countryCode: 'CA',
    flagUrl: 'https://cdn.nur.kz/static/football/CA.png'
  }]
}, {
  id: 'groupG',
  name: 'Группа G',
  teams: [{
    id: 'I9l9aqLq',
    name: 'Бразилия',
    games: 3,
    points: 6,
    goalsScored: 3,
    goalsAgainst: 1,
    countryCode: 'BR',
    flagUrl: 'https://cdn.nur.kz/static/football/BR.png'
  }, {
    id: 'rHJ2vy1B',
    name: 'Швейцария',
    games: 3,
    points: 6,
    goalsScored: 4,
    goalsAgainst: 3,
    countryCode: 'CH',
    flagUrl: 'https://cdn.nur.kz/static/football/CH.png'
  }, {
    id: 'zk1uVG2D',
    name: 'Камерун',
    games: 3,
    points: 4,
    goalsScored: 4,
    goalsAgainst: 4,
    countryCode: 'CM',
    flagUrl: 'https://cdn.nur.kz/static/football/CM.png'
  }, {
    id: '8Kl6iq0i',
    name: 'Сербия',
    games: 3,
    points: 1,
    goalsScored: 5,
    goalsAgainst: 8,
    countryCode: 'RS',
    flagUrl: 'https://cdn.nur.kz/static/football/RS.png'
  }]
}, {
  id: 'groupH',
  name: 'Группа H',
  teams: [{
    id: 'WvJrjFVN',
    name: 'Португалия',
    games: 3,
    points: 6,
    goalsScored: 6,
    goalsAgainst: 4,
    countryCode: 'PT',
    flagUrl: 'https://cdn.nur.kz/static/football/PT.png'
  }, {
    id: 'K6Gs7P6G',
    name: 'Южная Корея',
    games: 3,
    points: 4,
    goalsScored: 4,
    goalsAgainst: 4,
    countryCode: 'KR',
    flagUrl: 'https://cdn.nur.kz/static/football/KR.png'
  }, {
    id: 'xMk44orG',
    name: 'Уругвай',
    games: 3,
    points: 4,
    goalsScored: 2,
    goalsAgainst: 2,
    countryCode: 'UY',
    flagUrl: 'https://cdn.nur.kz/static/football/UY.png'
  }, {
    id: 'nNBjHale',
    name: 'Гана',
    games: 3,
    points: 3,
    goalsScored: 5,
    goalsAgainst: 7,
    countryCode: 'GH',
    flagUrl: 'https://cdn.nur.kz/static/football/GH.png'
  }]
}];
